EMMY.contactsNew = {
  init: function () {
    $('.btn-new-contact').on('click', function(e) {
      e.preventDefault();
      $(this).next().toggleClass('showme');
    });

    $('#saveContact').on('click', function(e) {
      e.preventDefault();
      var dataForm = $(this).closest('form').serialize();
      var URL = '/contacts';
      $.ajax({
        url: URL,
        method: 'POST',
        data: dataForm,
        success: function (data) {
          // console.log(data, 'data saved');
        }
      });
    });
  }
};

